document.addEventListener('DOMContentLoaded', () => {
  const accordionCloseBtn = document.querySelectorAll('.accordion__btn-close');

  // Menu toggle buttons
  accordionCloseBtn.forEach((btn) => {
    btn.addEventListener('click', (e) => {
      const accordion = btn.closest('.accordion');
      accordion.removeAttribute('open');
    });
  });
});
